import { createContext } from 'react';
const CarouselContext = /*#__PURE__*/createContext({
  activeSlideIndex: 0,
  numberOfSlides: 0,
  hideButtonsOnEdges: false,
  paginate: () => void null
});
export { CarouselContext };
//# sourceMappingURL=CarouselContext.js.map
